var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Base } from "../../framework/base";
import { IdTitle } from "./idTitle";
var IdColorTitle = /** @class */ (function (_super) {
    __extends(IdColorTitle, _super);
    function IdColorTitle(obj) {
        var _this = _super.call(this, obj) || this;
        _this.color = obj && obj.color || "";
        return _this;
    }
    IdColorTitle.createIdColorTitle = function (id, color, title) {
        var result = new IdColorTitle();
        result.id = id;
        result.color = color;
        result.title = title;
        return result;
    };
    IdColorTitle.prototype.getHash = function () {
        return this.id + "#" + this.title + "#" + this.color;
    };
    IdColorTitle.getHash = function (items) {
        if (!items || items.length < 1)
            return "";
        return Base.joinSuffix(items.map(function (i) { return i.getHash(); }), "$");
    };
    IdColorTitle.sortIdTitles = function (items, asc) {
        if (!items && items.length < 2)
            return items;
        return items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.getTitle(), b.getTitle())); });
    };
    return IdColorTitle;
}(IdTitle));
export { IdColorTitle };
